/**
 * 
 * @enum {string}
 */
export const DataTypes = {
  INDEX: 'index',
  INDEX_REMOTE: 'index-remote',
  DATE: 'date',
  DATE_REMOTE: 'date-remote',
  FIXED: 'fixed',
  FIXED_REMOTE: 'fixed-remote'
};